import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Button } from '@tcc/crate';

// lodash
import isString from 'lodash/isString';

const BaseTrigger = ({
  className,
  content,
  dataTestId,
  disabled = false,
  handler,
  mode='link'
}) => {
  const classString = classNames({
    'vra-base-trigger': true,
    [className]: !!className
  });

  return isString(content) ? (
    <Button
      className={classString}
      data-test-id={dataTestId}
      disabled={disabled}
      mode={mode}
      type="button"
      onClick={handler}>
      {content}
    </Button>
  ) : content;
};
BaseTrigger.propTypes = {
  className: PropTypes.string,
  content: PropTypes.any.isRequired,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  handler: PropTypes.func,
  mode: PropTypes.string
};

export default BaseTrigger;
